import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'

import EventCarouselArrow from './eventCarouselArrow'
import EventCarouselItem from './eventCarouselItem'

import 'slick-carousel/slick/slick.css'
import './slick-theme.css'
import './style.scss'

class FullWidthCarousel extends React.Component {
  constructor(props){
    super(props)

    this.items = _.get(props, 'data.contentData', [])
    this.layout = _.get(props, 'layout.settings', [])

    this.state = { 
      desktopMode: window.innerWidth >= 1025,
      currentSlideIdx: 0,
    }
  }

  componentDidMount(){
    this.attachWindowResizeListener()
    this.disableSlideContainerFocus()
    this.disableTabbingDots()
  }
  
  attachWindowResizeListener() {
    window.addEventListener("resize", e => {
      this.setState({ desktopMode: window.innerWidth >= 1025 })
    });
  }
  
  disableSlideContainerFocus() {
    _.each(document.querySelectorAll('.slick-slide'), slide => {
      slide.tabIndex= "-1"
    })
  }
  
  //This code is rotten
  disableTabbingDots() {
    if(this.carousel.querySelector('.slick-dots') != null){ 
      var dotsSearch = setInterval( () => {
        let dotsContainer = this.carousel.querySelector('.slick-dots')
        if (!dotsContainer) return

        _.each(dotsContainer.querySelectorAll('button'), btn => {
          btn.dataset.noFocus = true
          btn.tabIndex = -1
        })
        clearInterval(dotsSearch)
      }, 300)
    } 
  }

  updateCurrentSlideIdx(newIdx) {
    this.setState({
      currentSlideIdx: newIdx
    })
  }

  render() {
    const hasMultipleItems = this.items.length > 1
    const isFullWidth = this.layout.isFullWidth
    const isHidden = this.layout.isHidden
    const loop = this.layout.loop

    return (
      <div 
        ref={el => this.carousel = el} 
        className={`event-carousel ` + (isHidden ? 'hide' : '') + (isFullWidth? 'full-width' : '')}
      >
        {/* FOR SCREENREADERS */}
        {/* !isFullWidth && <div 
          className="current-item-label"
          aria-live="polite"
          aria-atomic="true"
        >
          { `Slide ${this.state.currentSlideIdx + 1} of ${this.items.length} slides`}
        </div> */}

        { this.items.length > 0 && 
          <Slider
            ref={ el => this.slider = el }
            dots={hasMultipleItems && !isFullWidth}
            arrows={hasMultipleItems}
            accessibility={false}
            afterChange={this.updateCurrentSlideIdx.bind(this)}
            prevArrow={
              <EventCarouselArrow 
                hide={this.state.currentSlideIdx === 0}
              />
            }
            nextArrow={
              <EventCarouselArrow 
                hide={this.state.currentSlideIdx === (this.items.length - 1)}
              />
            }
            speed={750}
            centerMode={!isFullWidth && this.state.desktopMode && true}
            cssEase="ease-in-out"
            slidesToShow={1}
            infinite={true}
            centerPadding={!isFullWidth && this.state.desktopMode && '300px'}
            autoplay={loop}
            autoplaySpeed={30000}
          >
          { this.items.map((item, i) => (
            <div key={i}>
              <EventCarouselItem 
                index={i}
                item={item}
                isFullWidth={isFullWidth}
              />
            </div>
          ))}
        </Slider>
      }
      </div>
    )
  }
}

export default FullWidthCarousel;
